<template>
  <div
    class="flex flex-col p-5 rounded-md border border-[#272727] alpha-bottom shade"
  >
    <slot />
  </div>
</template>

<script setup>
  defineOptions({
    name: "Frame",
  })
</script>
